import { DEVICE_TYPE_DESKTOP_WIDE } from '../../../general/js/app';

export const rowNames = {
    TALL: 'TALL',
    TALL_REVERSE: 'TALL_REVERSE',
    NARROW: 'NARROW',
    NARROW_REVERSE: 'NARROW_REVERSE',
    TWO_THIRDS_AND_ONE_THIRD: 'TWO_THIRDS_AND_ONE_THIRD',
    ONE_THIRD_AND_TWO_THIRDS: 'ONE_THIRD_AND_TWO_THIRDS',
    DOUBLE_TWO_THIRDS: 'DOUBLE_TWO_THIRDS',
    TRIPLE_ONE_THIRD: 'TRIPLE_ONE_THIRD'
};

const rowPattern = {
    [rowNames.TALL]: {
        modifiers: ['tall'],
        slots: [
            {
                type: 'tall',
                modifiers: ['tall'],
            }
        ]
    },
    [rowNames.TALL_REVERSE]: {
        modifiers: ['tall-reverse'],
        slots: [
            {
                type: 'tall',
                modifiers: ['tall', 'tall-reverse'],
            }
        ]
    },
    [rowNames.NARROW]: {
        modifiers: ['narrow'],
        slots: [
            {
                type: 'narrow',
                modifiers: ['narrow']
            }
        ]
    },
    [rowNames.NARROW_REVERSE]: {
        modifiers: ['narrow-reverse'],
        slots: [
            {
                type: 'narrow',
                modifiers: ['narrow', 'narrow-reverse']
            }
        ]
    },
    [rowNames.TWO_THIRDS_AND_ONE_THIRD]: {
        modifiers: ['two-thirds-and-one-third'],
        slots: [
            {
                type: 'two-thirds',
                modifiers: ['two-thirds']
            },
            {
                type: 'one-third',
                modifiers: ['one-third']
            }
        ]
    },
    [rowNames.ONE_THIRD_AND_TWO_THIRDS]: {
        modifiers: ['one-third-and-two-thirds'],
        slots: [
            {
                type: 'one-third',
                modifiers: ['one-third']
            },
            {
                type: 'two-thirds',
                modifiers: ['two-thirds']
            }
        ]
    },
    [rowNames.DOUBLE_TWO_THIRDS]: {
        modifiers: ['double-two-thirds'],
        slots: [
            {
                type: 'two-thirds',
                modifiers: ['two-thirds']
            },
            {
                type: 'two-thirds',
                modifiers: ['two-thirds']
            }
        ]
    },
    [rowNames.TRIPLE_ONE_THIRD]: {
        modifiers: ['triple-one-third'],
        slots: [
            {
                type: 'one-third',
                modifiers: ['one-third']
            },
            {
                type: 'one-third',
                modifiers: ['one-third']
            },
            {
                type: 'one-third',
                modifiers: ['one-third']
            }
        ]
    }
};

const getTall = (deviceType) => {
    switch (deviceType) {
        default:
            return rowPattern[rowNames.TALL];
    }
};

const getTallReverse = (deviceType) => {
    switch (deviceType) {
        default:
            return rowPattern[rowNames.TALL_REVERSE];
    }
};

const getNarrow = (deviceType) => {
    switch (deviceType) {
        default:
            return rowPattern[rowNames.NARROW];
    }
};

const getNarrowReverse = (deviceType) => {
    switch (deviceType) {
        default:
            return rowPattern[rowNames.NARROW_REVERSE];
    }
};

const getTwoThirdsAndOneThird = (deviceType) => {
    switch (deviceType) {
        case DEVICE_TYPE_DESKTOP_WIDE:
            return rowPattern[rowNames.TWO_THIRDS_AND_ONE_THIRD];
        default:
            return rowPattern[rowNames.DOUBLE_TWO_THIRDS];
    }
};

const getOneThirdAndTwoThirds = (deviceType) => {
    switch (deviceType) {
        case DEVICE_TYPE_DESKTOP_WIDE:
            return rowPattern[rowNames.ONE_THIRD_AND_TWO_THIRDS];
        default:
            return rowPattern[rowNames.DOUBLE_TWO_THIRDS];
    }
};

const getTrippleOneThird = (deviceType) => {
    switch (deviceType) {
        default:
            return rowPattern[rowNames.TRIPLE_ONE_THIRD];
    }
};

export const getPatternByDeviceType = (patternName, deviceType) => {
    switch (patternName) {
        case rowNames.TALL:
            return getTall(deviceType);
        case rowNames.TALL_REVERSE:
            return getTallReverse(deviceType);
        case rowNames.NARROW:
            return getNarrow(deviceType);
        case rowNames.NARROW_REVERSE:
            return getNarrowReverse(deviceType);
        case rowNames.TWO_THIRDS_AND_ONE_THIRD:
            return getTwoThirdsAndOneThird(deviceType);
        case rowNames.ONE_THIRD_AND_TWO_THIRDS:
            return getOneThirdAndTwoThirds(deviceType);
        case rowNames.TRIPLE_ONE_THIRD:
            return getTrippleOneThird(deviceType);
        default:
            console.log('Unknown row pattern name');
            return null;
    }
};

export default rowPattern;
